/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { ICreateOrderArgs } from "./components";

const is = require("is_js");

const SERVICE_NAME = "PurchasedCostumeListPageService";
const log: any = LoggerModule.getInstance();

export class PurchasedCostumeListPageService {
  private static instance: PurchasedCostumeListPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): PurchasedCostumeListPageService {
    if (!PurchasedCostumeListPageService.instance) {
      PurchasedCostumeListPageService.instance =
        new PurchasedCostumeListPageService(props);
    }
    return PurchasedCostumeListPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getBoxes(args?: any) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getBoxes(args);

    return content;
  }

  public async getBoxesYear() {
    let content: any = [];
    const agent = getAgent();

    content = await agent.getBoxesYear();
    return content;
  }

  public async getInfo(args?: any) {
    let content: any = [];
    const agent = getAgent();

    content = await agent.getInfo(args);
    return content;
  }

  public async createOrder(payload: ICreateOrderArgs) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.createOrder(payload);

    return content;
  }

  public async getPastPurchaseOne(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getPastBoxesOne(arg);
    console.log(content);
    return content;
  }

  public async getPastPurchase(arg: any) {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getPastBoxes(arg);
    console.log(content, "qhd89");
    return content;
  }
  public async getBrandDetails() {
    let content: any = {};
    const agent = getAgent();
    content = await agent.getBrandDetails();
    console.log(content, "qhd89");
    return content;
  }
}
